import React from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'
import styled from 'styled-components'
import {Tab as RmwcTab} from '@rmwc/tabs'
import '@rmwc/tabs/styles'

const FilteredRmwcTab = (props) => <RmwcTab {..._.omit(props, ['isDisabled'])} />

const StyledRmwcTab = styled(FilteredRmwcTab)`
  &&& .mdc-tab__text-label {
    text-transform: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 1rem;
    letter-spacing: 0px;
  }
  &&& .mdc-tab-indicator__content {
    border-width: 3px;
  }
  ${({isDisabled}) =>
    isDisabled &&
    `
    &&& {
      cursor: initial;
    }
    &&&, body &&&:not(.mdc-tab--active) .mdc-tab__text-label {
       color: var(--mdc-theme-disabled);
    }
    &&&:not(.mdc-tab--active) .mdc-tab__text-label {
      opacity: 1;
    }
  `}
`

const Tab = ({children, isDisabled, onClick, ...otherProps}) => (
  <StyledRmwcTab onClick={onClick && isDisabled ? undefined : onClick} isDisabled={isDisabled} {...otherProps}>
    {children}
  </StyledRmwcTab>
)

Tab.propTypes = {
  children: PropTypes.any,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
}

export {Tab}
